import axios from 'axios'
import apiList from './resource.js'

export default {
  // 用户搜索历史列表
  getHistoryList: function (successfn, errorfn) {
    return axios
      .get(apiList.search.historyList)
      .then(res => {
        successfn && successfn(res.data)
      })
      .catch(res => {
        errorfn && errorfn(res.data)
      })
  },
  // 新增用户搜索历史
  postAddSearch: function (data, successfn, errorfn) {
    return axios.post(apiList.search.addSearch, data)
      .then(res => {
        successfn && successfn(res.data)
      })
      .catch(res => {
        errorfn && errorfn(res.data)
      })
  },
  // 搜索结果列表
  getSearchList: function (data, successfn, errorfn) {
    return axios
      .get(apiList.search.searchList, {
        params: data
      })
      .then(res => {
        successfn && successfn(res.data)
      })
      .catch(res => {
        errorfn && errorfn(res.data)
      })
  },
  // 搜索结果详情
  getSearchDetail: function (data, successfn, errorfn) {
    return axios
      .get(apiList.search.searchDetail, {
        params: data
      })
      .then(res => {
        successfn && successfn(res.data)
      })
      .catch(res => {
        errorfn && errorfn(res.data)
      })
  },
  // 热门搜索标签列表
  getHotSearch: function (successfn, errorfn) {
    return axios
      .get(apiList.search.hotSearch)
      .then(res => {
        successfn && successfn(res.data)
      })
      .catch(res => {
        errorfn && errorfn(res.data)
      })
  }
}



// WEBPACK FOOTER //
// ./src/fetch/search.js